<template>
  <b-container fluid>
    <b-row>
      <h2 style="margin-left: 15px">{{title}}</h2>
      <b-alert :show="loading" variant="info">Bezig met laden...</b-alert>
      <b-alert v-model="errorMessageVisible" variant="danger" dismissible>{{errorMessage}}</b-alert>
    </b-row>
    <b-row class="errorOverviewRow" style="min-height: 360px;">
      <div class="errorOverviewColumnLeft">
        <b-table striped hover outlined
                 style="line-height:0.6;"
                 id="filterTable"
                 :items="filters"
                 :fields="filterfields"
                 :select-mode="'single'"
                 sticky-header="330px"
                 no-select-on-click
                 ref="filtersTableRef"
                 selectable
                 @row-clicked="filtersSelected">
        </b-table>
      </div>
      <div class="errorOverviewColumnMiddle">
        <b-table striped hover outlined
                 style="line-height:0.6;"
                 id="errorsTable"
                 sticky-header="330px"
                 :items="errors"
                 :fields="fields"
                 :filter="filter"
                 :filter-included-fields="filterOn"
                 :select-mode="'single'"
                 responsive
                 no-select-on-click
                 ref="errorsTableRef"
                 @filtered="onFiltered"
                 selectable
                 @row-clicked="onSelectionChanged"
                 sort-icon-left
                 label-sort-asc=""
                 label-sort-desc=""
                 label-sort-clear="">
        </b-table>
      </div>
      <div class="errorOverviewColumnRight">
        <center><b-button class="errorOverviewButton" id="setIgnore" @click="setIgnore" :disabled="selectedId == ''">Negeren</b-button></center>
        <center><b-button class="errorOverviewButton" id="processAgain" @click="processAgain" :disabled="selectedId == ''">Opnieuw verwerken</b-button></center>
        <br />
        <center><b-button class="errorOverviewButton" id="ignoreAllOfType" @click="ignoreAllOfType" :disabled="Object.keys(this.selectedFilter).length === 0">Alles van dit type negeren</b-button></center>
        <center><b-button class="errorOverviewButton" id="opnieuw verwerken" @click="processAllOfTypeAgain" :disabled="Object.keys(this.selectedFilter).length === 0">Alles van dit type opnieuw verwerken</b-button></center>
      </div>
    </b-row>
    <b-row class="errorOverviewRow">
      <div class="errorViewEditor">
        <label>Payload:</label>
        <div class="errorOverviewEditorStyle">
          <textarea id="payload_editor"></textarea>
        </div>
      </div>
      <div class="errorViewEditor">
        <label>Response:</label>
        <div class="errorOverviewEditorStyle">
          <textarea id="response"></textarea>
        </div>
      </div>
      <b-button id="save" style="margin-top: 15px; margin-left: 10px; width: 15%" @click="save" :disabled="selectedId == ''">Opslaan en opnieuw verwerken</b-button>
    </b-row>
  </b-container>
</template>

<script>
  import ErrorHandlerMixin from '@/mixins/ErrorHandlerMixin'
  import * as CodeMirror from 'codemirror';
  import 'codemirror/lib/codemirror.css';
  import 'codemirror/theme/mdn-like.css';
  import 'codemirror/mode/javascript/javascript';
  import 'codemirror/mode/xml/xml';

  export default {
    name: 'ErrorOverview',
    mixins: [ErrorHandlerMixin],
    data() {
      return {
        title: 'Overzicht foutmeldingen',
        loading: false,
        errors: [],
        filters: [],
        selectedId: '',
        selectedError: {},
        selectedFilter: {},
        selectedPayload: "",
        confirmed: false,
        itemSaved: false,
        oldType: "",
        fields: [
          {
            key: 'payloadQueueID',
            label: 'Id',
            class: 'tablefont',
            sortable: true,
          },
          {
            key: 'importedDD',
            formatter: 'formatDateAssigned',
            label: 'Importdatum',
            class: 'tablefont',
            sortable: true,
            filterByFormatted: true
          },
          {
            key: 'processedDD',
            formatter: 'formatDateAssigned',
            label: 'Verwerkt op',
            class: 'tablefont',
            sortable: true,
            filterByFormatted: true
          },
          {
            key: 'reference',
            label: 'Referentie',
            class: 'tablefont',
          },
          {
            key: 'result',
            label: 'Resultaat',
            class: 'tablefont',
          },
          {
            key: 'modifyDD',
            formatter: 'formatDateAssigned',
            label: 'Gewijzigd op',
            class: 'tablefont',
            sortable: true,
            filterByFormatted: true
          }
        ],
        filterfields: [
          {
            key: 'type',
            label: 'Type',
            class: 'typeColumn tablefont'
          },
          {
            key: 'amount',
            label: 'Aantal',
            tdClass: 'text-right',
            class: 'amountColumn tablefont'
          },
        ],
        filter: null,
        filterOn: ['payloadType', 'reference', 'importedDD', 'processedDD']
      };
    },
    mounted() {
      this.cm_payload = CodeMirror.fromTextArea(document.getElementById('payload_editor'), {
        lineNumbers: true,
        indentWithTabs: true,
        theme: 'mdn-like',
        value: String,
        mode: { name: 'javascript', json: true }
      })
      this.cm_response = CodeMirror.fromTextArea(document.getElementById('response'), {
        lineNumbers: true,
        indentWithTabs: true,
        readOnly: true,
        theme: 'mdn-like',
        value: String,
        mode: { name: 'javascript', json: true }
      })
    },
    created: function () {
      this.loading = true;
      this.$api.get('payload/filterlist')
        .then((response) => {
          this.filters = response.data
        })
        .catch((error) => {
          this.handleHttpError(error, 'Er ging iets fout bij het ophalen van de foutmelding types.')
        })
        .finally(() => {
          this.loading = false
        })
    },
    computed: {
    },
    methods: {
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      async processAgain() {
        var payload = this.cm_payload.getValue();
        if (payload == '') {
          this.showErrorMessage('U kunt geen lege payload opnieuw verwerken.', null);
          return;
        }

        if (await confirm('Weet u zeker dat u dit record opnieuw wilt verwerken?')) {
          this.loading = true;
          this.$api.post('payload/', this.selectedError)
            .then(() => {
              this.selectedId = '';
              this.spliceLists();
              this.resetTables();
            })
            .catch((error) => {
              this.handleHttpError(error, 'Er ging iets fout bij bij het opslaan.')
            })
            .finally(() => {
              this.loading = false
            })
        }
      },
      async save() {
        var payload = this.cm_payload.getValue();
        if (payload == '') {
          this.showErrorMessage('U kunt geen lege payload opslaan.', null);
          return;
        }

        if (await confirm('Weet u zeker dat u dit record wilt opslaan en verwerken?')) {
          this.selectedError.payload = payload;
          this.loading = true;
          this.$api.post('payload/', this.selectedError)
            .then(() => {
              this.selectedId = '';
              this.spliceLists();
              this.resetTables();
            })
            .catch((error) => {
              this.handleHttpError(error, 'Er ging iets fout bij bij het opslaan.')
            })
            .finally(() => {
              this.loading = false
            })
        }
      },
      async setIgnore() {
        if (await confirm('Weet u zeker dat u dit record wilt negeren?')) {
          this.loading = true;
          this.$api.post('payload/updateignore/' + this.selectedId)
            .then(() => {
              this.selectedId = '';
              this.spliceLists();
              this.resetTables();
            })
            .catch((error) => {
              this.handleHttpError(error, 'Er ging iets fout bij bij het updaten.')
            })
            .finally(() => {
              this.loading = false
            })
        }
      },
      async ignoreAllOfType() {
        if (await confirm('Weet u zeker dat u alles van dit type wilt negeren?')) {
          this.loading = true;
          this.$api.post('payload/SetPayloadQueuesToIgnore/' + this.selectedFilter.type)
            .then(() => {
              this.selectedId = '';

              this.errors = []
              var filterIndex = this.filters.indexOf(this.selectedFilter)
              this.filters.splice(filterIndex, 1);
              this.selectedFilter = {};
              this.$refs.filtersTableRef.refresh();
            })
            .catch((error) => {
              this.handleHttpError(error, 'Er ging iets fout bij bij het updaten.')
            })
            .finally(() => {
              this.loading = false
            })
        }
      },
      async processAllOfTypeAgain() {
        if (await confirm('Weet u zeker dat u alles van dit type opnieuw wilt verwerken?\r\n\r\nDeze regels worden niet direct verwerkt, maar pas wanneer deze taak wordt uitgevoerd dit kan enige tijd duren.')) {
          this.loading = true;
          this.$api.post('payload/SetPayloadQueuesToNull/' + this.selectedFilter.type)
            .then(() => {
              this.selectedId = '';

              this.errors = []
              var filterIndex = this.filters.indexOf(this.selectedFilter)
              this.filters.splice(filterIndex, 1);
              this.selectedFilter = {};
              this.$refs.filtersTableRef.refresh();
            })
            .catch((error) => {
              this.handleHttpError(error, 'Er ging iets fout bij bij het updaten.')
            })
            .finally(() => {
              this.loading = false
            })
        }
      },
      async onSelectionChanged(item, index, event) {
        // Prevents an error on unselecting the row
        if (typeof (item) !== 'object') {
          return;
        }
        // payloads differentiate in encoding their url, so this way it compares the raw values.
        if (this.selectedPayload.replace(/[\n\r]/g, '') !== this.cm_payload.getValue('').replace(/[\n\r]/g, '') && this.itemSaved === false) {
          if (await confirm('Uw wijzigingen gaan verloren, wilt u doorgaan?')) {
            this.confirmed = true
          }
        }

        if (this.selectedPayload.replace(/[\n\r]/g, '') === this.cm_payload.getValue('').replace(/[\n\r]/g, '') || this.confirmed || this.itemSaved) {
          this.$refs.errorsTableRef.selectRow(index);
          this.selectedId = item.payloadQueueID
          this.selectedPayload = item.payload
          this.selectedError = item
          this.cm_payload.setValue(item.payload)
          this.cm_response.setValue(item.responseRaw)
          if (item.payloadLanguage == 'xml') {
            this.cm_response.setOption('mode', 'xml')
            this.cm_payload.setOption('mode', 'xml')
          }
          else {
            this.cm_response.setOption('mode', { name: 'javascript', json: true })
            this.cm_payload.setOption('mode', { name: 'javascript', json: true })
          }
          this.confirmed = false
          this.itemSaved = false
        }
      },
      filtersSelected(item, index, event) {
        //this.loading = true;
        this.selectedFilter = item
        var filterlist = []
        if (this.oldType === item.type) {
          return;
        }
        this.selectedId = '';
        this.$refs.filtersTableRef.selectRow(index);
        filterlist[0] = item.type
        this.$api.get('payload/list/', { params: { filterlist: filterlist } })
          .then((response) => {
            this.errors = response.data
            this.resetTables()
          })
          .catch((error) => {
            this.handleHttpError(error, 'Er ging iets fout bij het ophalen van de gefilterde foutmeldingen.')
          })
        this.oldType = item.type
        //.finally(() => {
        //  this.loading = false
        //})
      },
      formatDateAssigned(value) {
        if (value === null || value === "") {
          return ""
        }
        var date = new Date(value)
        var formattedDate = date.toLocaleDateString() + " " + date.toLocaleTimeString()
        return formattedDate;
      },
      spliceLists() {
        var index = this.errors.indexOf(this.selectedError);
        if (index > -1) {
          this.errors.splice(index, 1);
        }

        var filterIndex = this.filters.indexOf(this.selectedFilter)
        if (filterIndex > -1) {
          this.filters[filterIndex].amount = this.filters[filterIndex].amount - 1;
          if (this.filters[filterIndex].amount < 1) {
            this.filters.splice(filterIndex, 1);
          }
        }
        this.$refs.filtersTableRef.refresh();
      },
      resetTables() {
        this.itemSaved = true
        this.cm_payload.setValue('')
        this.cm_response.setValue('')
      }
    }
  }
</script>
<style>
  .tablefont {
    font-size: small;
  }

  .cm-s-mdn-like .cm-string {
    font-size: small;
    color: #07a;
    font-style: italic;
  }

  .CodeMirror {
    line-height: 1.0;
  }

  .amountColumn {
    text-align: end
  }

  .typeColumn {
    overflow: hidden;
    max-width: 230px;
  }
</style>



// WEBPACK FOOTER //
// src/components/errors/ErrorOverview.vue